module.exports = __webpack_public_path__ + "img/fit.8637bd59.svg";